@use "ui/styles/colors";

/**
 * Adapted from https://www.cssscript.com/realistic-ios-switch-pure-css/
 */
.wrapper {
  :global {
    .toggle {
      display: flex;
      cursor: pointer;
      -webkit-tap-highlight-color: transparent;
    }

    // Space around knob in off position
    .toggle i {
      position: relative;
      display: inline-block;
      margin-right: 0.5rem;
      width: 44px;
      height: 24px;
      background-color: colors.$gray60;
      border-radius: 23px;
      vertical-align: text-bottom;
      transition: all 0.3s linear;
    }

    // Right space of knob in off position
    .toggle i::before {
      content: "";
      position: absolute;
      left: 0;
      width: 42px;
      height: 22px;
      background-color: colors.$gray60;
      border-radius: 11px;
      transform: translate3d(2px, 2px, 0) scale3d(1, 1, 1);
      transition: all 0.25s linear;
    }

    // Knob
    .toggle i::after {
      content: "";
      position: absolute;
      left: 0;
      width: 20px;
      height: 20px;
      background-color: colors.$white;
      border-radius: 11px;
      box-shadow:
        0px 3px 8px rgba(0, 0, 0, 0.15),
        0px 3px 1px rgba(0, 0, 0, 0.06);
      transform: translate3d(2px, 2px, 0);
      transition: all 0.2s ease-in-out;
    }

    .toggle:active i::after {
      width: 28px;
      transform: translate3d(2px, 2px, 0);
    }

    .toggle:active input:checked + i::after {
      transform: translate3d(16px, 2px, 0);
    }

    .toggle input {
      display: none;
    }

    .toggle input:checked + i::before {
      transform: translate3d(18px, 2px, 0) scale3d(0, 0, 0);
    }

    .toggle input:checked + i::after {
      transform: translate3d(22px, 2px, 0);
    }

    // On position
    .toggle input:checked + i {
      background-color: colors.$green;
    }
  }

  &.small {
    transform: scale(0.8);
    :global {
      .toggle input:checked + i {
        background-color: colors.$blue;
      }
    }
  }

  &.xsmall {
    --toggle-width: 24px;
    --toggle-height: 14px;
    --toggle-padding: 2px;
    --toggle-border-radius: 7px;

    :global {
      .toggle {
        i {
          width: var(--toggle-width);
          height: var(--toggle-height);
          border-radius: var(--toggle-border-radius);
          margin-right: 0;

          &::before {
            width: calc(var(--toggle-width) - 2px);
            height: calc(var(--toggle-height) - 2px);
            border-radius: calc(var(--toggle-border-radius) - 1px);
          }

          &::after {
            width: calc(var(--toggle-height) - (var(--toggle-padding) * 2));
            height: calc(var(--toggle-height) - (var(--toggle-padding) * 2));
            border-radius: 50%;
          }
        }

        &:active {
          i::after {
            width: calc(var(--toggle-height) - var(--toggle-padding));
          }
        }

        input:checked + i {
          background-color: colors.$blue;

          &::before {
            transform: translate3d(calc(var(--toggle-width) - var(--toggle-height)), var(--toggle-padding), 0)
              scale3d(0, 0, 0);
          }

          &::after {
            transform: translate3d(calc(var(--toggle-width) - var(--toggle-height)), var(--toggle-padding), 0);
          }
        }
      }
    }
  }

  &.disabled {
    :global {
      .toggle {
        cursor: not-allowed;
      }

      .toggle i,
      .toggle i::before {
        background-color: colors.$gray40;
      }

      .toggle input:checked + i {
        background-color: colors.$gray30;
      }
    }
  }
}
